import { PropsWithChildren, useContext } from "react";

import { join, ScopeContext } from "./hooks";

export function ScopedForm({ prefix = "", children }: PropsWithChildren<{ prefix?: string }>) {
  const parent = useContext(ScopeContext);
  const full = join(parent, prefix);
  return <ScopeContext.Provider value={full}>{children}</ScopeContext.Provider>;
}
